import { Picto } from '@zolteam/zol-admin-ui';
// Style
import { useEffect } from 'react';
import styles from './Message.module.css';

const SELF_CLOSING_DELAY = 3000;

/**
 * Message component.
 * @param {object} props
 * @param {string} props.text
 * @param {number} props.id
 * @param {'info' | 'alert' | 'success' | 'warning'} props.type
 * @param {Function} props.onClose
 * @param {boolean} [props.isSelfClosing = false]
 * @param {string} [props.className = null]
 * @returns {JSX.Element}
 */
function Message({
  text, id, type, onClose, isSelfClosing = false, className = null,
}) {
  // Handlers
  /**
   * Handles the message closing.
   * @returns {void}
   */
  const handleCloseMessage = () => onClose(id);
  // Effects
  useEffect(() => {
    if (isSelfClosing) {
      const timer = setTimeout(() => {
        handleCloseMessage();
      }, SELF_CLOSING_DELAY);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, []);

  return (
    <div
      id={`message-${id}`}
      className={[styles.message,
        styles[type],
        isSelfClosing ? styles['slef-closing'] : '',
        className].join(' ')}
    >
      <button
        type="button"
        onClick={handleCloseMessage}
        className={styles.btn}
        aria-label="Close"
      >
        <Picto className={styles.close} icon="cross" />
      </button>
      <p className={styles.text}>{text}</p>
      {isSelfClosing
        ? (
          <div
            className={styles.time}
            style={{ animationDuration: `${SELF_CLOSING_DELAY}ms` }}
          />
        )
        : null}
    </div>
  );
}

export default Message;
